__turbopack_context__.v({
  "stackItem": "aZiPJq_stackItem",
});
